import React, { useState, useEffect, useRef } from 'react'
import { gautiPrisiminimoNuotrauka } from '../utils/nuotrauku_saugykla'
import { santykinisLaikas } from '../utils/prisiminimai'

// Pilno ekrano prisiminimų peržiūra. Swipe kairė/dešinė per grupės nuotraukas.
// grupe = { pavadinimas, elementai: [{ id, data, pavadinimas }] }
function PrisiminimuGalerija({ grupe, onClose }) {
  const [idx, setIdx] = useState(0)
  const [nuotraukos, setNuotraukos] = useState({}) // id → dataUrl
  const touchX = useRef(null)

  const elementai = grupe ? grupe.elementai : []

  useEffect(() => {
    if (!grupe) return
    setIdx(0)
    let gyvas = true
    Promise.all(elementai.map(async e => [e.id, await gautiPrisiminimoNuotrauka(e.id)]))
      .then(poros => { if (gyvas) setNuotraukos(Object.fromEntries(poros)) })
    return () => { gyvas = false }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [grupe])

  if (!grupe) return null

  const dabartinis = elementai[idx]
  const dataUrl = dabartinis ? nuotraukos[dabartinis.id] : null

  function pirmyn() { setIdx(i => Math.min(i + 1, elementai.length - 1)) }
  function atgal() { setIdx(i => Math.max(i - 1, 0)) }

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: '#0C1310', zIndex: 1300, display: 'flex', flexDirection: 'column' }}
      onTouchStart={(e) => { touchX.current = e.touches[0].clientX }}
      onTouchEnd={(e) => {
        if (touchX.current == null) return
        const d = e.changedTouches[0].clientX - touchX.current
        touchX.current = null
        if (d < -50) pirmyn()
        else if (d > 50) atgal()
      }}
    >
      {/* Viršus */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 'calc(14px + env(safe-area-inset-top)) 16px 10px', flexShrink: 0 }}>
        <button onClick={onClose} aria-label="Uždaryti" style={{ width: 38, height: 38, borderRadius: '50%', background: 'rgba(240,232,213,0.1)', border: 'none', color: '#F0E8D5', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12" /></svg>
        </button>
        {elementai.length > 1 && (
          <div style={{ display: 'flex', gap: 6 }}>
            {elementai.map((e, i) => (
              <div key={e.id} style={{ width: i === idx ? 18 : 6, height: 6, borderRadius: 3, background: i === idx ? '#E5A840' : 'rgba(240,232,213,0.3)', transition: 'all 0.25s ease' }} />
            ))}
          </div>
        )}
        <div style={{ width: 38 }} />
      </div>

      {/* Nuotrauka */}
      <div style={{ flex: 1, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', minHeight: 0 }}>
        {dataUrl ? (
          <img src={dataUrl} alt={dabartinis.pavadinimas || 'Prisiminimas'} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
        ) : (
          <div style={{ color: '#7A8A7E', fontSize: 13 }}>Kraunama…</div>
        )}

        {/* Strėlės (desktop) */}
        {idx > 0 && (
          <button onClick={atgal} aria-label="Atgal" style={{ position: 'absolute', left: 8, top: '50%', transform: 'translateY(-50%)', width: 40, height: 40, borderRadius: '50%', background: 'rgba(12,19,16,0.6)', border: 'none', color: '#F0E8D5', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
          </button>
        )}
        {idx < elementai.length - 1 && (
          <button onClick={pirmyn} aria-label="Pirmyn" style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', width: 40, height: 40, borderRadius: '50%', background: 'rgba(12,19,16,0.6)', border: 'none', color: '#F0E8D5', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
          </button>
        )}
      </div>

      {/* Info */}
      <div style={{ flexShrink: 0, padding: '16px 22px calc(24px + env(safe-area-inset-bottom))', textAlign: 'center' }}>
        <h2 style={{ fontFamily: "'Lora', Georgia, serif", color: '#F0E8D5', fontSize: 22, fontWeight: 500, margin: 0 }}>
          {dabartinis?.pavadinimas || 'Prisiminimas'}
        </h2>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 8 }}>
          <span style={{ width: 20, height: 2, background: '#E5A840' }} />
          <span style={{ color: '#7A8A7E', fontSize: 13 }}>{dabartinis ? santykinisLaikas(dabartinis.data) : ''}</span>
        </div>
      </div>
    </div>
  )
}

export default PrisiminimuGalerija
